const Theme = {
  logo_image_url: 'presenceautochtone.png',
  logo_height: 90,

  body_background_color: '#fbecc0',

  button_color: '#8a2c63',
  button_text_uppercase: true,
  button_half_border_color: '#8a2c63',

  text_font: `'Tahoma', 'sans-serif'`,
  title_font: `'Tahoma', 'sans-serif'`,
}

export default Theme
